import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { NotificationManager } from 'react-notifications';
import { useMsal } from '@azure/msal-react';
import useFetchVendors from './useFetchVendors';
import { msalConfig } from '../auth/authConfig';
import { errorHandler } from '../utils/helpers';
import useUserStore from '../store/userStore';
import { acquireToken } from '../utils/auth';

interface EditVendorContactRequest {
  id: string | number;
  token: string | null;
  setError: (data: any) => any;
  setLoading: (data: any) => any;
  fetchVendors: () => void;
  data: EditModelDTO;
};

const editVendorContactRequest = async ({
    token,
    setError,
    setLoading,
    fetchVendors,
    data,
    id,
  }: EditVendorContactRequest) => {
  try {
    const response = await axios.put(`${window.__env.REACT_APP_API_URL || process.env.REACT_APP_API_URL}/Vendor/Contact/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json, text/plain, */*',
      },
    });
    if (response.status === 200) {
      NotificationManager.success('Vendor Contact is successfully edited');
    }
  } catch (error) {
    errorHandler(error, setError);
  } finally {
    fetchVendors();
    setLoading(false);
  }
};

interface EditModelDTO { name: string, email: string, phoneNumber: string, vendorId: number };

interface EditVendorContact {
  editVendorContact: (id: string | number, formData: EditModelDTO) => void;
  loading: boolean;
  error: Error | null;
};

const useEditVendorContact = (): EditVendorContact => {
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);
  const { fetchVendors } = useFetchVendors();

  const { user } = useUserStore();

  const editVendorContact = async (id, formData: EditModelDTO) => {
    if (accounts.length > 0) {
      const accessTokenRequest = {
        scopes: [`${msalConfig.auth.clientId}/.default`],
        account: accounts[0],
      };

      if (!user) return navigate('/sign-in');

      const data: EditModelDTO = formData;

      try {
        const accessToken = await acquireToken(instance, accessTokenRequest);
        editVendorContactRequest({
          id,
          token: accessToken,
          setError,
          fetchVendors,
          setLoading,
          data,
        });
      } catch (error) {
        errorHandler(error, setError);
      }
    } else {
      navigate('/sign-in');
    }
  }

  return { editVendorContact, loading, error };
};

export default useEditVendorContact;
